import { Head } from '@inertiajs/react';
import type { LiveShow } from '@/types';
import { EditionLiveView } from './components/EditionLiveView';
import { LiveView } from './components/LiveView';

// GET /:eventSlug/live. The two editions with a live directory of their own get the
// branded stage view inside their route group's theme; every other edition gets the
// plainer `[locale]/live` one, which carries the upvote counters.
export default function Show({
  eventSlug,
  initialData,
  edition,
  title,
  description,
  ogImageUrl,
}: LiveShow) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
        {ogImageUrl && (
          <>
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImageUrl} />
          </>
        )}
      </Head>
      {edition ? (
        <>
          <EditionLiveView
            eventSlug={eventSlug}
            initialData={initialData}
            edition={edition}
          />
        </>
      ) : (
        <LiveView eventSlug={eventSlug} initialData={initialData} />
      )}
    </>
  );
}
